import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_menu-profile",
  "use": "svg_menu-profile-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 12\" id=\"svg_menu-profile\"><circle cx=\"5\" cy=\"3\" r=\"2\" stroke=\"#99CC57\" stroke-width=\"2\" /><path d=\"M9 11v-.429A3.571 3.571 0 0 0 5.429 7H4.57A3.571 3.571 0 0 0 1 10.571V11\" stroke=\"#99CC57\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol